module.exports = __webpack_public_path__ + "static/img/finance-type-home.3ccd9484.svg";